<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" (click)="windowClick()">
  <dialog-header [label]="'ACTIONS.SEARCH' | translate" [dialogRef]='dialogRef' [object]='this'></dialog-header>
  <mat-dialog-content style="overflow-x: hidden;">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <mat-icon class="search-icon">search</mat-icon>
      <mat-form-field class="search-form-field">
        <input matInput type="text" autocomplete="off" [value]="searchPattern"
          (input)="onSearchPatternInput($event.target.value)">
        <button matButton *ngIf="searchPattern" matSuffix mat-icon-button
          (click)="clearSearchPattern()"><mat-icon>close</mat-icon></button>
      </mat-form-field>
    </div>
    <div>
      <mat-action-list dense>
        <div class="no-items-label" *ngIf="foundObjectsTitles.length == 0">{{'EURO.NOT_FOUND' | translate}}</div>
        <mat-list-item *ngFor="let foundObject of foundObjectsTitles; let i = index" [innerHTML]="foundObject"
          (click)="onFoundObjectClick(foundObject, i)"></mat-list-item>
      </mat-action-list>
    </div>
  </mat-dialog-content>
</div>